export enum OperationalStatusCode {
  GOOD_WORKING_ORDER = 'W',
  NOT_WORKING = 'N',
}
